import { render, staticRenderFns } from "./RegistroVentaAdmin.vue?vue&type=template&id=ec1a2a98"
import script from "./RegistroVentaAdmin.vue?vue&type=script&lang=js"
export * from "./RegistroVentaAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports